import React from "react";
import { Input, Button } from "antd";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Selecting from "Components/Selecting/Selecting";
import CropperImage from "Components/CropperImage/CropperImage";
import logo from "svg/logo.svg";
import AuthAside from "Components/AuthAside/AuthAside";
import AuthFooter from "Components/AuthFooter/AuthFooter";

const validationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
});

const ProfileDetails = () => {
  return (
    <div className="auth-grid">
      <div className="auth-dialog-container">
        <div className="auth-dialog">
          <div className="text-center text-brand-color mb-36">
            <img src={logo} style={{ width: "218px" }} alt="" />
            <div className="h2 mt-16">Company admin</div>
            <div className="h1 mt-56">Complete your profile details</div>
          </div>
          <Formik
            initialValues={{ email: "", password: "", rememberMe: false }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              console.log(values);
            }}
          >
            {({ values, handleChange, handleBlur }) => (
              <Form>
                <div className="vl-fieldset is-vertical">
                  <div className="vl-form-group is-vertical">
                    <label className="vl-label">Email</label>
                    <Field
                      as={Input}
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                    <ErrorMessage name="email" component="div" className="vl-error" />
                  </div>
                  <div className="vl-form-group is-vertical">
                    <label className="vl-label">Firts Name*</label>
                    <Field
                      as={Input}
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                    <ErrorMessage name="email" component="div" className="vl-error" />
                  </div>
                  <div className="vl-form-group is-vertical">
                    <label className="vl-label">Last Name*</label>
                    <Field
                      as={Input}
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                    <ErrorMessage name="email" component="div" className="vl-error" />
                  </div>
                  <div className="vl-form-group is-vertical">
                    <label className="vl-label">Nickname*</label>
                    <Field
                      as={Input}
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                    <ErrorMessage name="email" component="div" className="vl-error" />
                  </div>
                  <div className="vl-form-group is-vertical">
                    <label className="vl-label">Country*</label>
                    <Selecting />
                  </div>
                  <div className="vl-form-group is-vertical">
                    <label className="vl-label">Timezone*</label>
                    <Selecting />
                  </div>
                  <div className="vl-form-group is-vertical">
                    <label className="vl-label">Upload your profile picture*</label>
                    <CropperImage />
                  </div>
                  <Button type="primary" htmlType="submit">
                    Login
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>

      <AuthAside />
      <AuthFooter />
    </div>
  );
};

export default ProfileDetails;
